<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import MmMenu from '../base/MmMenu.vue'
import MmIcon from '../base/MmIcon.vue'
import { studioLinks } from './navigation'
import './studio-tools.css'
const props = defineProps<{ mobile?: boolean }>()
const { t } = useI18n()
const route = useRoute()
const open = ref(false)
const ids = ['song','lyrics','rap','rapName','cover','video','clips','vocal']
const colors = ['var(--accent)','var(--pop-sun)','var(--pop-tang)','var(--pop-pink)','var(--pop-sky)','var(--pop-violet)','var(--tool-clips)','var(--tool-vocal)']
// Keep the accepted desktop menu's ordered icon + title + description rows.
// The mobile sheet uses the same entries and adds the full tool directory.
const items = computed(() => [
  ...studioLinks.map((link, index) => ({
    id: link.to,
    to: link.to,
    label: t(props.mobile && index === 0 ? 'mm.shell.song' : `t24a.tools.${ids[index]}.name`),
    icon: link.icon,
    color: colors[index],
    meta: t(`t24a.tools.${ids[index]}.desc`),
  })),
  ...(props.mobile ? [
    { divider: true as const },
    { id: '/studio', to: '/studio', label: t('mm.studio.allTools'), icon: 'grid' as const },
  ] : []),
])
watch(() => route.fullPath, () => { open.value = false })
</script>

<template>
  <MmMenu v-model="open" :label="t(mobile ? 'mm.shell.makeWhat' : 'mm.shell.studio')" :items="items" :mobile-breakpoint="mobile ? 1024 : 768" :title="mobile ? t('mm.shell.makeWhat') : undefined" variant="mega">
    <template #trigger="{ toggle, expanded, id }">
      <button v-if="mobile" type="button" class="tab-create" :class="{ 'is-current': route.path === '/studio' || route.path.startsWith('/album-cover/') || studioLinks.some(link => route.path === link.to) }" :aria-label="t('nav.create')" aria-haspopup="menu" :aria-expanded="expanded" :aria-controls="expanded ? id : undefined" @click="toggle">
        <span class="fab"><MmIcon name="plus" :size="22" /></span><span>{{ t('nav.create') }}</span>
      </button>
      <button v-else type="button" class="studio-btn" aria-haspopup="menu" :aria-expanded="expanded" :aria-controls="expanded ? id : undefined" @click="toggle">{{ t('mm.shell.studio') }}<MmIcon name="down" :size="16" /></button>
    </template>
  </MmMenu>
</template>
